import { localDayISO } from './localDay.js'

// IDEA-MEMORY-CAPTURE-BRIDGE-001 (Rob 2026-10-02, "Go ahead with the capture
// prompts"). Collectors already answer "Where did it come from?" after adding a
// bottle, and already log compliments, but neither ever reached the Memory Log,
// so "On this day" and "Feels like this memory" had nothing to work with. These
// helpers turn those moments into Memory Log entries, only on an explicit tap or
// a visible, checked box. Rows go to the collector's own owner-only share_log.

export const MEMORY_DIRECTIONS = new Set(['gave', 'received', 'connection'])

/** The Memory Log form a link asked the log page to open, if any. */
export function requestedMemoryDirection(state) {
  const direction = state?.addMemory
  return MEMORY_DIRECTIONS.has(direction) ? direction : null
}

/** Where "Remember this moment" goes after a compliment: the bottle's Memory Log, Connection form open. */
export function rememberMomentLink(fragranceId) {
  if (!fragranceId) return null
  return { pathname: `/fragrance/${fragranceId}/log`, state: { addMemory: 'connection' } }
}

/** True when the after-add answer is a gift with a giver's name and the box is still checked. */
export function shouldSaveGiftMemory(values) {
  return values?.acquired_from_kind === 'gift'
    && Boolean((values.acquired_from_name || '').trim())
    && values.remember_gift !== false
}

/** Save "Received from <name>" for a gifted bottle. Returns the row, or null when nothing applies. */
export async function saveGiftMemory(client, { userId, fragrance, values }) {
  if (!userId || !fragrance?.id || !shouldSaveGiftMemory(values)) return null
  const { data, error } = await client
    .from('share_log')
    .insert({
      user_id: userId,
      fragrance_id: fragrance.id,
      catalog_id: fragrance.catalog_id || null,
      direction: 'received',
      person_name: values.acquired_from_name.trim(),
      share_format: null,
      shared_on: values.acquired_on || localDayISO(),
      note: null,
    })
    .select('id')
    .single()
  if (error) throw error
  return data
}
